export const SisetuPreviewTab = {
  Basic: 'basic',
  Doctors: 'doctors',
  Dpc: 'dpc',
  Cancer: 'cancer',
  Trial: 'trial',
  Research: 'research',
  Journal: 'journal'
} as const

export type SisetuPreviewTabType = (typeof SisetuPreviewTab)[keyof typeof SisetuPreviewTab]

